import { render, staticRenderFns } from "./CTFLeviathan.vue?vue&type=template&id=6013ffdb&scoped=true&"
import script from "./CTFLeviathan.vue?vue&type=script&lang=js&"
export * from "./CTFLeviathan.vue?vue&type=script&lang=js&"
import style0 from "./CTFLeviathan.vue?vue&type=style&index=0&id=6013ffdb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013ffdb",
  null
  
)

export default component.exports